// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AiRouteImport } from './routes/ai'
import { Route as AiAutomationRouteImport } from './routes/ai-automation'
import { Route as ArizonaHomeServicesPpcAgencyRouteImport } from './routes/arizona-home-services-ppc-agency'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as CaseStudiesRouteImport } from './routes/case-studies'
import { Route as ChandlerPpcAgencyRouteImport } from './routes/chandler-ppc-agency'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as GoogleAdsForHvacCompaniesArizonaRouteImport } from './routes/google-ads-for-hvac-companies-arizona'
import { Route as GoogleAdsForRoofingCompaniesArizonaRouteImport } from './routes/google-ads-for-roofing-companies-arizona'
import { Route as IndustriesRouteImport } from './routes/industries'
import { Route as MesaPpcAgencyRouteImport } from './routes/mesa-ppc-agency'
import { Route as PhoenixPpcAgencyRouteImport } from './routes/phoenix-ppc-agency'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ScottsdalePpcAgencyRouteImport } from './routes/scottsdale-ppc-agency'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as AiAutomationIndexRouteImport } from './routes/ai-automation.index'
import { Route as AiAutomationCompanyBrainRouteImport } from './routes/ai-automation.company-brain'
import { Route as AiAutomationCustomSoftwareRouteImport } from './routes/ai-automation.custom-software'
import { Route as AiAutomationReceptionistRouteImport } from './routes/ai-automation.receptionist'
import { Route as AiAutomationWorkflowsRouteImport } from './routes/ai-automation.workflows'
import { Route as AuditERouteImport } from './routes/audit_.e'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as GlossaryIndexRouteImport } from './routes/glossary.index'
import { Route as GlossarySlugRouteImport } from './routes/glossary.$slug'
import { Route as IndustriesIndexRouteImport } from './routes/industries.index'
import { Route as IndustriesIndustryRouteImport } from './routes/industries.$industry'
import { Route as ResearchIndexRouteImport } from './routes/research.index'
import { Route as ResearchConversionTrackingReportRouteImport } from './routes/research.conversion-tracking-report'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesServiceRouteImport } from './routes/services.$service'
import { Route as ServicesLocalServicesAdsForRoofersRouteImport } from './routes/services.local-services-ads-for-roofers'
import { Route as AuditRTokenRouteImport } from './routes/audit_.r.$token'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AiRoute = AiRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => rootRouteImport
          })
const AiAutomationRoute = AiAutomationRouteImport.update({
            id: '/ai-automation',path: '/ai-automation',getParentRoute: () => rootRouteImport
          })
const ArizonaHomeServicesPpcAgencyRoute = ArizonaHomeServicesPpcAgencyRouteImport.update({
            id: '/arizona-home-services-ppc-agency',path: '/arizona-home-services-ppc-agency',getParentRoute: () => rootRouteImport
          })
const AuditRoute = AuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const ChandlerPpcAgencyRoute = ChandlerPpcAgencyRouteImport.update({
            id: '/chandler-ppc-agency',path: '/chandler-ppc-agency',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const GoogleAdsForHvacCompaniesArizonaRoute = GoogleAdsForHvacCompaniesArizonaRouteImport.update({
            id: '/google-ads-for-hvac-companies-arizona',path: '/google-ads-for-hvac-companies-arizona',getParentRoute: () => rootRouteImport
          })
const GoogleAdsForRoofingCompaniesArizonaRoute = GoogleAdsForRoofingCompaniesArizonaRouteImport.update({
            id: '/google-ads-for-roofing-companies-arizona',path: '/google-ads-for-roofing-companies-arizona',getParentRoute: () => rootRouteImport
          })
const IndustriesRoute = IndustriesRouteImport.update({
            id: '/industries',path: '/industries',getParentRoute: () => rootRouteImport
          })
const MesaPpcAgencyRoute = MesaPpcAgencyRouteImport.update({
            id: '/mesa-ppc-agency',path: '/mesa-ppc-agency',getParentRoute: () => rootRouteImport
          })
const PhoenixPpcAgencyRoute = PhoenixPpcAgencyRouteImport.update({
            id: '/phoenix-ppc-agency',path: '/phoenix-ppc-agency',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ScottsdalePpcAgencyRoute = ScottsdalePpcAgencyRouteImport.update({
            id: '/scottsdale-ppc-agency',path: '/scottsdale-ppc-agency',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const AiAutomationIndexRoute = AiAutomationIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AiAutomationRoute
          })
const AiAutomationCompanyBrainRoute = AiAutomationCompanyBrainRouteImport.update({
            id: '/company-brain',path: '/company-brain',getParentRoute: () => AiAutomationRoute
          })
const AiAutomationCustomSoftwareRoute = AiAutomationCustomSoftwareRouteImport.update({
            id: '/custom-software',path: '/custom-software',getParentRoute: () => AiAutomationRoute
          })
const AiAutomationReceptionistRoute = AiAutomationReceptionistRouteImport.update({
            id: '/receptionist',path: '/receptionist',getParentRoute: () => AiAutomationRoute
          })
const AiAutomationWorkflowsRoute = AiAutomationWorkflowsRouteImport.update({
            id: '/workflows',path: '/workflows',getParentRoute: () => AiAutomationRoute
          })
const AuditERoute = AuditERouteImport.update({
            id: '/audit_/e',path: '/audit/e',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/glossary/',path: '/glossary/',getParentRoute: () => rootRouteImport
          })
const GlossarySlugRoute = GlossarySlugRouteImport.update({
            id: '/glossary/$slug',path: '/glossary/$slug',getParentRoute: () => rootRouteImport
          })
const IndustriesIndexRoute = IndustriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => IndustriesRoute
          })
const IndustriesIndustryRoute = IndustriesIndustryRouteImport.update({
            id: '/$industry',path: '/$industry',getParentRoute: () => IndustriesRoute
          })
const ResearchIndexRoute = ResearchIndexRouteImport.update({
            id: '/research/',path: '/research/',getParentRoute: () => rootRouteImport
          })
const ResearchConversionTrackingReportRoute = ResearchConversionTrackingReportRouteImport.update({
            id: '/research/conversion-tracking-report',path: '/research/conversion-tracking-report',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesServiceRoute = ServicesServiceRouteImport.update({
            id: '/$service',path: '/$service',getParentRoute: () => ServicesRoute
          })
const ServicesLocalServicesAdsForRoofersRoute = ServicesLocalServicesAdsForRoofersRouteImport.update({
            id: '/local-services-ads-for-roofers',path: '/local-services-ads-for-roofers',getParentRoute: () => ServicesRoute
          })
const AuditRTokenRoute = AuditRTokenRouteImport.update({
            id: '/audit_/r/$token',path: '/audit/r/$token',getParentRoute: () => rootRouteImport
          })





const AiAutomationRouteChildren = {
  AiAutomationCompanyBrainRoute: AiAutomationCompanyBrainRoute,AiAutomationCustomSoftwareRoute: AiAutomationCustomSoftwareRoute,AiAutomationReceptionistRoute: AiAutomationReceptionistRoute,AiAutomationWorkflowsRoute: AiAutomationWorkflowsRoute,AiAutomationIndexRoute: AiAutomationIndexRoute
}

const AiAutomationRouteWithChildren = AiAutomationRoute._addFileChildren(AiAutomationRouteChildren)




const IndustriesRouteChildren = {
  IndustriesIndustryRoute: IndustriesIndustryRoute,IndustriesIndexRoute: IndustriesIndexRoute
}

const IndustriesRouteWithChildren = IndustriesRoute._addFileChildren(IndustriesRouteChildren)




const ServicesRouteChildren = {
  ServicesServiceRoute: ServicesServiceRoute,ServicesLocalServicesAdsForRoofersRoute: ServicesLocalServicesAdsForRoofersRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AiRoute: AiRoute,AiAutomationRoute: AiAutomationRouteWithChildren,ArizonaHomeServicesPpcAgencyRoute: ArizonaHomeServicesPpcAgencyRoute,AuditRoute: AuditRoute,CaseStudiesRoute: CaseStudiesRoute,ChandlerPpcAgencyRoute: ChandlerPpcAgencyRoute,ContactRoute: ContactRoute,ContactUsRoute: ContactUsRoute,GoogleAdsForHvacCompaniesArizonaRoute: GoogleAdsForHvacCompaniesArizonaRoute,GoogleAdsForRoofingCompaniesArizonaRoute: GoogleAdsForRoofingCompaniesArizonaRoute,IndustriesRoute: IndustriesRouteWithChildren,MesaPpcAgencyRoute: MesaPpcAgencyRoute,PhoenixPpcAgencyRoute: PhoenixPpcAgencyRoute,PrivacyRoute: PrivacyRoute,ScottsdalePpcAgencyRoute: ScottsdalePpcAgencyRoute,ServicesRoute: ServicesRouteWithChildren,AuditERoute: AuditERoute,BlogSlugRoute: BlogSlugRoute,GlossarySlugRoute: GlossarySlugRoute,ResearchConversionTrackingReportRoute: ResearchConversionTrackingReportRoute,BlogIndexRoute: BlogIndexRoute,GlossaryIndexRoute: GlossaryIndexRoute,ResearchIndexRoute: ResearchIndexRoute,AuditRTokenRoute: AuditRTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)